import React, { HTMLAttributes, useState } from 'react';
import { useObserver, useLocalStore } from 'mobx-react-lite';
import styled from 'styled-components/macro';
import { useMst } from '../models/WithWineState';
import CartBadge from './CartBadge';
import { CartDispatchData } from '../types/EventDataProps';
import { dispatchCartData } from '../utils/dispatchHelper';
import { MenuCartLinkProps } from '../types/MenuCartLinkProps';

const UnstyledMenuCartLink: React.FC<MenuCartLinkProps> = ({ className }) => {
  const l = '#';
  const stateTree = useMst();
  const [hasFocus, setFocus] = useState(false);
  const state = useLocalStore(() => ({
    get cartEventDataItems() {
      const cartItems: CartDispatchData[] = [];
      stateTree.session?.cart.forEach((x: CartDispatchData) => {
        const cart = {
          product: {
            id: x.product.id,
            skuCode: x.product.skuCode,
            name: x.product.name,
            vintage: x.product.vintage,
            wineType: x.product.wineType,
            productType: x.product.productType,
            productGroup: x.product.productGroup,
          },
          quantity: x.quantity,
        };
        cartItems.push(cart);
      });

      return cartItems;
    },

    onClick(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) {
      event.preventDefault();
      event.stopPropagation();
      stateTree.widgets.cart.show();
      dispatchCartData(state.cartEventDataItems);
    },
  }));

  const cartMenuLinkClass = `ww-widget ww-menu-cart-link${
    className ? ` ${className}` : ``
  }`;

  return useObserver(() => (
    <a
      href={l}
      style={{
        zIndex: hasFocus ? 0 : 1,
      }}
      className={cartMenuLinkClass}
      onFocus={() => setFocus(true)}
      onBlur={() => setFocus(false)}
      onClick={state.onClick}
    >
      Cart
      <CartBadge />
    </a>
  ));
};

const MenuCartLink = styled(UnstyledMenuCartLink)`
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  font-size: inherit;
  font-family: inherit;

  .ww-cart-badge {
    margin-left: 0.5em;
  }
`;

export default MenuCartLink;
